import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";
import {CancelToken} from "axios";

/**@inheritDoc*/
export class ReportingToolsController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the list of task status groups from the server.
     * @param reportName        the name of the section to fetch the columns for.
     * @param cancelToken   the abort controller to cancel the request.
     */
    public async fetchDynamicColumns(reportName: string, cancelToken?: CancelToken): models.FetchDynamicColumnsResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.reportingTools.getColumns,
            params: {
                reportName: reportName,
            },
            cancelToken: cancelToken,
        });
    }
}


export * from "./index.types";
export default ReportingToolsController;
